import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { getApiBaseUrl } from '../config/urls';

// 定数定義
const TOKEN_KEY = 'token';
const AUTH_API_PREFIX = '/api/auth/';
const REDIRECT_ON_UNAUTHORIZED = '/auth/login';

// axios インスタンス生成
const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

// ログ出力をまとめる
function log(message: string, ...optionalParams: any[]) {
  console.log(`[apiClient] ${message}`, ...optionalParams);
}

// 認証系APIかどうかを判定
function isAuthApiRequest(url?: string): boolean {
  return url?.includes(AUTH_API_PREFIX) ?? false;
}

// ローカルストレージからトークンを取得
function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

// Authorization ヘッダーを付与
function attachAuthorizationHeader(config: AxiosRequestConfig, token: string): AxiosRequestConfig {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${token}`,
  };

  const authHeader = config.headers.Authorization;
  if (typeof authHeader === 'string') {
    log('Authorization header set:', authHeader.slice(0, 30) + '...');
  }

  return config;
}

// リクエストインターセプター
apiClient.interceptors.request.use(
  (config) => {
    if (isAuthApiRequest(config.url)) {
      log('Auth API detected, skipping Authorization header. URL:', config.url);
      return config;
    }

    const token = getStoredToken();
    log('Token exists:', !!token);

    if (!token) {
      log('No token found, skipping Authorization header. URL:', config.url);
      return config;
    }

    return attachAuthorizationHeader(config, token);
  },
  (error: AxiosError) => Promise.reject(error)
);

// レスポンスインターセプター
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const isUnauthorized = status === 401;

    if (isUnauthorized) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = REDIRECT_ON_UNAUTHORIZED;
    }

    return Promise.reject(error);
  }
);

export default apiClient;
